import { supabase } from '../supabase/client';
import { getAuthenticatedClient } from '../supabase/authenticatedClient';

export const getTour = async id => {
  const client = await getAuthenticatedClient();
  const { data, error } = await client.from('tours').select('*').eq('id', id).single();

  if (error) {
    throw error;
  }

  return data;
};

export const getTours = async () => {
  const { data, error } = await supabase
    .from('tours')
    .select(
      `
      *,
      cities (
        name,
        state
      ),
      tour_stops (
        id,
        stop_number,
        description,
        duration,
        place:places (
          name,
          address
        )
      )
    `
    )
    .order('name');

  if (error) {
    throw error;
  }

  return data;
};

export const createTour = async tourData => {
  const client = await getAuthenticatedClient();
  const { data, error } = await client.from('tours').insert([tourData]).select().single();

  if (error) {
    throw error;
  }

  return data;
};

export const updateTour = async (id, tourData) => {
  const client = await getAuthenticatedClient();
  const { data, error } = await client
    .from('tours')
    .upsert({ ...tourData, id })
    .select()
    .single();

  if (error) {
    throw error;
  }

  return data;
};

export const deleteTour = async id => {
  const client = await getAuthenticatedClient();
  const { error } = await client.from('tours').delete().eq('id', id);

  if (error) {
    throw error;
  }
};
